import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface TenantDataTabProps {
  tenant: {
    id: string;
    name: string;
    slug: string;
    email: string | null;
    status: string;
    trial_ends_at: string | null;
    created_at: string;
  };
}

export function TenantDataTab({ tenant }: TenantDataTabProps) {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString("pt-BR");
  };

  const getStatusBadge = (status: string) => {
    const variants: Record<string, "default" | "secondary" | "destructive" | "outline"> = {
      trial: "secondary",
      active: "default",
      suspended: "destructive",
      cancelled: "outline",
    };
    return variants[status] || "outline";
  };

  return (
    <div className="grid gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Informações Básicas</CardTitle>
          <CardDescription>Dados principais do cliente</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">ID</p>
              <code className="text-xs bg-muted px-2 py-1 rounded block mt-1">
                {tenant.id}
              </code>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Status</p>
              <Badge variant={getStatusBadge(tenant.status)} className="mt-1">
                {tenant.status}
              </Badge>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Nome</p>
              <p className="text-base mt-1">{tenant.name}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Slug</p>
              <code className="text-xs bg-muted px-2 py-1 rounded block mt-1">
                {tenant.slug}
              </code>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Email</p>
              <p className="text-base mt-1">{tenant.email || "-"}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Data de Criação</p>
              <p className="text-base mt-1">{formatDate(tenant.created_at)}</p>
            </div>
          </div>

          <div>
            <p className="text-sm font-medium text-muted-foreground">Trial Termina em</p>
            <p className="text-base mt-1">{formatDate(tenant.trial_ends_at)}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
